import { render, staticRenderFns } from "./StaffDM.vue?vue&type=template&id=96ad9138&scoped=true"
import script from "./StaffDM.vue?vue&type=script&lang=js"
export * from "./StaffDM.vue?vue&type=script&lang=js"
import style0 from "./StaffDM.vue?vue&type=style&index=0&id=96ad9138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ad9138",
  null
  
)

export default component.exports